import { NgModule } from '@angular/core';
import { ConfigurationsAccordionComponent } from './configurations-accordion.component';
import { NgSharedModule } from '../../../ng/ng-shared.module';
import { AngularSharedModule } from '../../../angularShared/angularShared.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { DesignFactoryModule } from '../../../designFactory/designFactory.module';
import { IsConfigEditablePipe } from './is-config-editable.pipe';
import { GetSelectedConfigurationPipe } from './get-selected-configuration.pipe';
import { ConfigurationParametersModule } from '../configuration-parameters/configuration-parameters.module';

@NgModule({
  declarations: [
    ConfigurationsAccordionComponent,
    IsConfigEditablePipe,
    GetSelectedConfigurationPipe,
  ],
  imports: [
    NgSharedModule,
    AngularSharedModule,
    PipesModule,
    DesignFactoryModule,
    ConfigurationParametersModule
  ],
  exports: [
    ConfigurationsAccordionComponent,
    ConfigurationParametersModule
  ],
})
export class AccordionModule {
}
